module.exports = __webpack_public_path__ + "static/media/05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_04.83b7d7c3.jpg";